module.exports = __webpack_public_path__ + "images/fa-cme-leaderboard.webp";